import React, {memo} from 'react';
import classNames from 'classnames';
import './HiddenStopAndStartButton.scss';
type HiddenStopAndStartButtonProps = {
  onClick: () => void;
  className: string;
  swiperAutoPlay: string;
};

const HiddenStopAndStartButton = ({className, swiperAutoPlay, onClick}: HiddenStopAndStartButtonProps) => {
  return (
    <button onClick={onClick} className={classNames('hidden-stop-and-start-button', className)}>
      {swiperAutoPlay}
    </button>
  );
};

export default memo(HiddenStopAndStartButton);
